import type React from 'react';

import { Link, useNavigate } from 'react-router';

import { HelsenorgeUrls, Urls } from '../types/ExtendEnums';
import type { HNVelgBehandlingsstedFrontend } from '../types/Resources';

import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';
import Title from '@helsenorge/designsystem-react/components/Title';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';

import type { Suggestion } from '@helsenorge/autosuggest/components/autosuggest';
import PageHeader from '@helsenorge/core-framework/page-header';
import PageLoader from '@helsenorge/core-framework/page-loader';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';
import { getHelsenorgeUrl } from '@helsenorge/framework-utils/hn-proxy-service';

import { useResources } from '../resources';
import AutosuggestComponent from '../shared/autosuggest';
import { useGetSokBehandlingerQuery, useGetSokBehandlingerSuggestionsQuery } from '../store/api/velgBehandlingsstedApi';
import { HN_VELG_BEHANDLINGSSTED_FRONTEND } from '../utils/resources-project';

import './styles.scss';

const Forside: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const resources = useResources<HNVelgBehandlingsstedFrontend>(HN_VELG_BEHANDLINGSSTED_FRONTEND);

  const { isLoading: loadingSokBehandlinger } = useGetSokBehandlingerQuery();

  const { data: allSuggestions = [] } = useGetSokBehandlingerSuggestionsQuery();

  const handleSuggestionSelected = (suggestion: Suggestion): void => {
    navigate(`${Urls.VentetiderForBehandling}?bid=${suggestion.value}`);
  };

  return (
    resources && (
      <PageLoader resources={resources} loading={loadingSokBehandlinger} labelId={getSidetittelId()}>
        <div className="container">
          <PageHeader title={resources.forsideTittel} description={resources.forsideIngress} tjenesteNavn="velg-behandlingssted" />
        </div>

        <div className="vbs-forside__content-wrapper">
          <div className="container">
            <Title htmlMarkup="h2" appearance={'title3'} margin={1}>
              {resources.forsideBehandlingerOgUndersokelser}
            </Title>

            <AutosuggestComponent
              label={resources.forsideSokLabel}
              containerLabel={resources.behandlingerTittel}
              allSuggestions={allSuggestions}
              handleSuggestionSelected={handleSuggestionSelected}
            />

            <ul className={`vbs-forside__lenker ${designsystemtypography['anchorlink-wrapper']}`}>
              <li>
                <Link to={Urls.Behandlinger}>{resources.forsideLinkBehandlinger}</Link>
              </li>
              <li>
                <Link to={Urls.Behandlingssteder}>{resources.forsideLinkBehandlingssteder}</Link>
              </li>
              <li>
                <AnchorLink href={`${getHelsenorgeUrl()}${HelsenorgeUrls.Avtalespesialister}`}>
                  {resources.forsideLinkAvtalespesialister}
                </AnchorLink>
              </li>
            </ul>
          </div>
        </div>
      </PageLoader>
    )
  );
};

export default Forside;
